// Site-wide SEO constants. Single source of truth for origin, brand name, and
// the default social-share image used across OpenGraph + Twitter cards.

export const SITE_URL = 'https://www.alrajhibank.com.my'
export const SITE_NAME = 'alrajhi bank Malaysia'

/** Default share card (1200x630). Generated by scripts/gen-og-assets.ts. */
export const DEFAULT_OG_IMAGE = '/og-default.png'

export const DEFAULT_TITLE = 'alrajhi bank Malaysia'
export const DEFAULT_DESCRIPTION =
  'Discover Shariah-compliant Islamic banking in Malaysia with alrajhi bank. Explore online banking, savings, financing, and wealth management solutions.'
